import React from 'react'
import Back from '../../common/Back'
import './about.css'
import img from '../images/support.png'
import i from '../images/support-2.png'
import Heading from '../../common/Heading'
const About = () => {
  return (
    <>
      <section className="about">
        <Back className='m' name='About Us' title='About Us - Who We Are?'  cover={img}/>
        <div className="container flex mtop">
            <div className=" row">
                <Heading title='Our Agency Story' subtitle='Check out our company story and work process.'/>

                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi, possimus autem? Excepturi, voluptates fugiat quaerat numquam iusto accusamus optio eos corporis. Earum exercitationem ex laborum quod est mollitia adipisci distinctio?</p>

                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Expedita voluptas sequi illum. Nesciunt, culpa, pariatur asperiores dicta omnis eveniet laboriosam minima dolore nisi assumenda, perferendis aspernatur ea veritatis excepturi quam.</p>
                <button className="btn2">More About Us</button>
            </div>
            <div className="right row">
                <img src={i} alt="" />
            </div>
        </div>
      </section>
    </>
  )
}

export default About
